
<div class="header-automovil">
    <div class="header-automovil__select">
        <div class="custom-select input-auto" (keyup)="onKeyDown($event)">
            <div [id]="id" [ngClass]="status && items.length !== 1 ? 'select-nowrap select-arrow-active select-selected' : 'select-nowrap select-selected'" (click)="onClickParent()" (clickOutside)="onClickedOutside($event)" ngbTooltip="{{(selectedText.length > 30)?selectedText:''}}" placement="button">
                {{selectedText}}
            </div>
            <div #select [ngClass]="[ 'select-items', status ? '' : 'select-hide',  isHeighShort() ? 'fixheight' : 'nofixheight']">
                <div [hidden]="items.length === 1" *ngFor="let element of items; let i = index" [ngClass]="selectedItem === i ? 'selected-item-element' : ''" (click)="onClickChild(element.idPoliza + '-' + element.idVoucher, element.patente + ' - ' +  element.marca + ' ' + element.modelo + ' - ' + element.anno)" #selectItem>
                    {{element.patente}} - {{element.marca}} {{element.modelo}} - {{element.anno}}
                </div>
            </div>
        </div>
    </div>
</div>
